'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _ingredientForm = require('./ingredient-form.component');

var _ingredientForm2 = _interopRequireDefault(_ingredientForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.product.ingredientForm', []).component('productIngredientForm', _ingredientForm2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/product/ingredient-form/ingredient-form.module.js